import {combineReducers} from '@modifi/redux'

import BuyerFormReducer from './store/form'
import BuyerViewReducer from './store/view'
import loadingLimitsReducer from './store/loadingLimits'

export default combineReducers({
  form: BuyerFormReducer,
  view: BuyerViewReducer,
  loadingLimits: loadingLimitsReducer,
})
